/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tough_Lime_Okapi_GrowInputs */

const fr_tough_lime_okapi_grow = /** @type {(inputs: Tough_Lime_Okapi_GrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer`)
};

/**

* @param {Tough_Lime_Okapi_GrowInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const tough_lime_okapi_grow = /** @type {((inputs?: Tough_Lime_Okapi_GrowInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tough_Lime_Okapi_GrowInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_tough_lime_okapi_grow(inputs)
});